export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc8dd9af6cd4251c11e1236f289916a1c748f942f&name=fetchTypeahead!'